import version from './version'

interface IConfig {
  rootPath: string
  ossRoot: string
  realEnv: string
  [key: string]: any
}

const envList: { [key: string]: IConfig } = {
  development: {
    site: 'https://mall.kuaipidev.com',
    rootPath: 'https://api.kuaipidev.com',
    ossRoot: 'https://dev.kuaipiyun.com/',
    realEnv: 'development',
  },
  testing: {
    site: 'https://mall.kuaipitest.com',
    rootPath: 'https://api.kuaipitest.com',
    ossRoot: 'https://dev.kuaipiyun.com/',
    realEnv: 'testing',
  },
  production: {
    site: 'https://mall.kuaipiyun.com',
    rootPath: 'https://api.kuaipiyun.com',
    ossRoot: 'https://files.kuaipiyun.com/',
    realEnv: 'production',
    isProd: true,
  },
}

export function getConfig(env?: string): IConfig {
  const config = envList[env || NODE_ENV]

  // 如果是在腾讯云流水线上构建，则生产环境使用不同的域名
  if (CLOUD_PLATFORM === 'tencent' && config.isProd) {
    config.rootPath = 'https://api.kuaipicloud.com'
  }

  const defaultConfig = {
    version,
    source: 104,
    language: 'zh_CN',
    designWidth: 750,
    loginExpirationDate: 1.5 * 60 * 60 * 1000, // 登录有效期 1.5 小时
  }

  return Object.assign(defaultConfig, config)
}
